<template>
  <div class="flex flex-col">
    <div class="md:-mt-10 flex justify-center rounded-full bg-white w-24 h-24 mx-auto">
      <span class="rounded-full text-blue-900 bg-gray-50 p-4 m-2">
        <svg role="presentation" focusable="false" tabindex="-1" class="icon w-12 h-12"   alt="" svg-inline  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="m2.18 7.6 1.95 9.83 18.75 10.83 7.54-13.05L11.66 4.38 2.18 7.61Zm10.84 6.3a3.3 3.3 0 1 0-5.7-3.3 3.3 3.3 0 0 0 5.7 3.3Z"/>
<path fill="#fff" d="M19.58 19.41a1.82 1.82 0 0 1 1.83-.91 1.79 1.79 0 0 1 1.26.72c.15.2.25.41.3.65.07.23.1.46.06.7a1.79 1.79 0 0 1-.72 1.26 1.85 1.85 0 0 1-2.05.13 1.9 1.9 0 0 1-.56-.5 2.1 2.1 0 0 1-.31-.63 2.1 2.1 0 0 1-.06-.71c.04-.25.12-.48.25-.7Zm2.39 1.38a.87.87 0 0 0 .1-.68.87.87 0 0 0-.43-.54.87.87 0 0 0-.69-.1.87.87 0 0 0-.54.42.87.87 0 0 0-.1.69c.07.24.2.42.43.54.22.13.45.16.68.1.24-.06.42-.2.55-.43Zm-4.73-6.88a1.82 1.82 0 0 1 1.83-.92 1.79 1.79 0 0 1 1.26.73c.15.2.25.4.3.64.08.23.1.47.06.7a1.79 1.79 0 0 1-.72 1.26 1.85 1.85 0 0 1-2.05.13 1.9 1.9 0 0 1-.56-.49 2.1 2.1 0 0 1-.31-.64 2.1 2.1 0 0 1-.06-.71c.04-.24.12-.48.25-.7Zm2.39 1.38a.87.87 0 0 0 .1-.69.87.87 0 0 0-.43-.54.87.87 0 0 0-.69-.1.87.87 0 0 0-.54.43.87.87 0 0 0-.1.68c.07.24.2.42.43.55.22.12.45.15.68.1.24-.07.42-.21.55-.43Zm3.76-.21.52.74-7.27 4.28-.53-.75 7.28-4.27Z"/>
</svg>
      </span>
    </div>
    <BackgroundImage
      class="h-16 max-w-1/3 mx-auto mt-2"
      size="contain"
      :src="providerLogo"
      :alt="providerDisplayName"
    />
    <PromotionDetails
      class="mt-4"
      :provider-display-name="providerDisplayName"
      :promotion="promotion"
    />
    <slot name="link" />
  </div>
</template>

<script lang="ts" setup>
import PromotionDetails from './promotion-details.vue'
import type { Promotion } from './types'

defineProps<{
  providerLogo: string
  providerDisplayName: string
  promotion: Promotion
}>()
</script>
